import React from 'react';
import { FadeIn } from './FadeIn';
export const HookSection = () => {
  return <section className="py-24 px-4 relative border-t border-sand bg-parchment-dark/50" data-id="element-108">
      <div className="max-w-3xl mx-auto text-center" data-id="element-109">
        <FadeIn data-id="element-110">
          <p className="text-2xl md:text-3xl font-playfair italic text-brown-heading leading-relaxed mb-8" data-id="element-111">
            "¿Alguna vez has sentido que no importa cuánto te esfuerces, cuánto
            medites o cuánta terapia hagas, terminas siempre en el mismo lugar?"
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-112">
          <p className="text-lg text-brown-warm/70 leading-relaxed mb-8" data-id="element-113">
            Las mismas relaciones vacías, la misma escasez financiera y esa
            ansiedad sorda que te visita a las 3 de la mañana recordándote que
            tu vida se siente como una copia de ayer.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-114">
          <div className="inline-block p-6 border border-gold/30 bg-gold-light/20 rounded-lg shadow-[0_0_30px_rgba(184,146,46,0.05)]" data-id="element-115">
            <p className="text-xl font-medium text-gold-antique" data-id="element-116">
              No es falta de voluntad. Es física.
            </p>
            <p className="mt-2 text-brown-warm" data-id="element-117">
              RENACER no es una opción, es una necesidad cuántica cuando el alma
              ya no soporta vivir en el pasado.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};